import { useSnackbar } from 'notistack';
import { useRef, useState, useEffect, useCallback  } from 'react';
import { useHistory } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, Typography, Grid } from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import MenuPopover from '../../components/MenuPopover';
import { useSelector, useDispatch } from 'react-redux';
import moment from "moment";
import { removeError, getClients } from 'src/redux/slices/client';
import {getUserList} from 'src/redux/slices/user';
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const history = useHistory();
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { logout, getUser } = useAuth();
  const [open, setOpen] = useState(false);
  const oAuthUser = useSelector(state => state.authJwt.oAuthUser);
  const errorhandle = useSelector(state => state.client.error);
  const [events, setEvents] = useState(['click', 'scroll']);
  const [hasToken, setHasToken] = useState(null);

  let timeStamp;
  let warningInactiveInterval = useRef();
  let startTimerInterval = useRef();
  
  const formatError = () => {
    setTimeout(() => {
      dispatch(removeError());
    }, 2000);
  }
  useEffect(() => {
    if ( errorhandle?.status === 'Unauthorized' ) {
      enqueueSnackbar(errorhandle?.message, { variant: 'error' });
      formatError();
    } if (errorhandle.message === 'Unauthenticated.') {
      handleLogout();
    }
  }, [errorhandle]);
  // start inactive check
  let timeChecker = () => {
    startTimerInterval.current = setTimeout(() => {
      let storedTimeStamp = localStorage.getItem("lastTimeStamp");
      warningInactive(storedTimeStamp);
    }, 1000);
  };
  // warning timer
  let warningInactive = (timeString) => {
    clearTimeout(startTimerInterval.current);

    warningInactiveInterval.current = setInterval(() => {
      const accessToken = window.localStorage.getItem('accessToken');
      if (!accessToken) {
        clearInterval(warningInactiveInterval.current);
        localStorage.removeItem("lastTimeStamp");
        handleLogout();
      }
      const maxTime = process.env.REACT_APP_LOGOUT_TIME || 1; // Maximum ideal time given before logout
      const diff = moment.duration(moment().diff(moment(timeString)));
      const minHor = diff.hours();
      if (minHor >= maxTime) {
        clearInterval(warningInactiveInterval.current);
        localStorage.removeItem("lastTimeStamp");
        handleLogout();
      }
    }, 500);
  };
  useEffect(() => {
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken) {
      setHasToken(true);
      setTimeout(() => {
        dispatch(getUserList());
        dispatch(getClients());
      }, 1000);
    }
    getUserData();
  }, []);
  // reset interval timer
  let resetTimer = useCallback(() => {
    clearTimeout(startTimerInterval.current);
    clearInterval(warningInactiveInterval.current);
  
    if (hasToken) {
      timeStamp = moment();
      localStorage.setItem("lastTimeStamp", timeStamp);
    } else {
      clearInterval(warningInactiveInterval.current);
      localStorage.removeItem("lastTimeStamp");
    }
    timeChecker();
  }, [hasToken]);
  
  useEffect(() => {
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });
  
    timeChecker();
  
    return () => {
      clearTimeout(startTimerInterval.current);
    };
  }, [resetTimer, events, timeChecker]);
  
  // // Life cycle hook
  // useEffect(() => {
  //   events.forEach((event) => {
  //     window.addEventListener(event, resetTimer);
  //   });

  // }, [resetTimer]);


  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getUserData = async () => {
    await getUser();
  };

  const handleLogout = async () => {
    try {
      await logout();
      if (isMountedRef.current) {
        // history.push('/');
        handleClose();
      }
      window.location.reload();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout', { variant: 'error' });
    }
  };

  const gotResetPage = async () => {
    history.push('/auth/update-password');
  };

  return (
    <>
      <Grid onClick={handleOpen} ref={anchorRef} sx={{cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center'}}>
        <img src={'/static/images/avartar.png'}  style={{ width: '32px', height: '32px' }}/>
        <img
          src={`/static/icons/navbar/arrow_down.svg`}
          style={{ width: 13, height: 8, marginLeft: '5px'}}
        />
        <label 
        style={{
          width: '12px', 
          height: '12px', 
          background: '#5FCFD1', 
          borderRadius: '50%', 
          color: '#263238', 
          fontSize: '8px',
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: 0,
          left: '20px'
        }}>
          {'3'}
        </label>
      </Grid>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }} >
          <Typography variant="subtitle1" className="text-break">
            {oAuthUser.name ?? oAuthUser.name }
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} className="text-break">
            {oAuthUser.email ?? oAuthUser.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />
        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={gotResetPage}
          >
            Reset your Password
          </Button>
        </Box>
        <Box sx={{ p: 2, pt: 0 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
